import { render } from "./Card.vue?vue&type=template&id=593b9850&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=593b9850&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-593b9850"

export default script